export default "__VITE_ASSET__Bome2e4W__"